module.exports = __webpack_public_path__ + "img/3d-tablet_en.7ce24c9.jpg";